export const MONTHS = {
  pt: [
    { id: 1, name: "Janeiro" },
    { id: 2, name: "Fevereiro" },
    { id: 3, name: "Março" },
    { id: 4, name: "Abril" },
    { id: 5, name: "Maio" },
    { id: 6, name: "Junho" },
    { id: 7, name: "Julho" },
    { id: 8, name: "Agosto" },
    { id: 9, name: "Setembro" },
    { id: 10, name: "Outubro" },
    { id: 11, name: "Novembro" },
    { id: 12, name: "Dezembro" },
  ],
  en: [
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" },
  ],
  es: [
    { id: 1, name: "Enero" },
    { id: 2, name: "Febrero" },
    { id: 3, name: "Marzo" },
    { id: 4, name: "Abril" },
    { id: 5, name: "Mayo" },
    { id: 6, name: "Junio" },
    { id: 7, name: "Julio" },
    { id: 8, name: "Agosto" },
    { id: 9, name: "Septiembre" },
    { id: 10, name: "Octubre" },
    { id: 11, name: "Noviembre" },
    { id: 12, name: "Diciembre" },
  ],
};

export const CURRENCIES = {
  pt: [
    { id: "brl", name: "BRL" },
    { id: "eur", name: "EUR" },
    { id: "dol", name: "USD" },
    { id: "gbp", name: "GBP" },
  ],
  en: [
    { id: "brl", name: "BRL" },
    { id: "eur", name: "EUR" },
    { id: "dol", name: "USD" },
    { id: "gbp", name: "GBP" },
  ],
  es: [
    { id: "brl", name: "BRL" },
    { id: "eur", name: "EUR" },
    { id: "dol", name: "USD" },
    { id: "gbp", name: "GBP" },
  ],
};

export const FREQUENCY = {
  pt: [
    { id: "SD", name: "Sob demanda" },
    { id: "D", name: "Diário" },
    { id: "S", name: "Semanal" },
    { id: "Q", name: "Quinzenal" },
    { id: "M", name: "Mensal" },
    { id: "B", name: "Bimestral" },
    { id: "T", name: "Trimestral" },
    { id: "A", name: "Anual" },
  ],
  en: [
    { id: "SD", name: "OnDemand" },
    { id: "D", name: "Daily" },
    { id: "S", name: "Weekly" },
    { id: "Q", name: "Biweekly" },
    { id: "M", name: "Monthly" },
    { id: "B", name: "Bimonthly" },
    { id: "T", name: "Quarterly" },
    { id: "A", name: "Yearly" },
  ],
  es: [
    { id: "SD", name: "Bajo demanda" },
    { id: "D", name: "Diario" },
    { id: "S", name: "Semanal" },
    { id: "Q", name: "Quincenal" },
    { id: "M", name: "Mensual" },
    { id: "B", name: "Bimensual" },
    { id: "T", name: "Trimestral" },
    { id: "A", name: "Anual" },
  ],
};

export const FREQUENCYMEETING = {
  pt: [
    { id: "D", name: "Diário" },
    { id: "S", name: "Semanal" },
    { id: "M", name: "Mensal" },
    { id: "A", name: "Anual" },
  ],
  en: [
    { id: "D", name: "Daily" },
    { id: "S", name: "Weekly" },
    { id: "M", name: "Monthly" },
    { id: "A", name: "Yearly" },
  ],
  es: [
    { id: "D", name: "Diario" },
    { id: "S", name: "Semanal" },
    { id: "M", name: "Mensual" },
    { id: "A", name: "Anual" },
  ],
};

export const ORDINAL_NUMBERS = {
  pt: [
    { id: 1, name: "Primeira(o)" },
    { id: 2, name: "Segunda(o)" },
    { id: 3, name: "Terceira(o)" },
    { id: 4, name: "Quarta(o)" },
    { id: 5, name: "Última(o)" },
  ],
  en: [
    { id: 1, name: "Primeira(o)" },
    { id: 2, name: "Segunda(o)" },
    { id: 3, name: "Terceira(o)" },
    { id: 4, name: "Quarta(o)" },
    { id: 5, name: "Última(o)" },
  ],
  es: [
    { id: 1, name: "Primeira(o)" },
    { id: 2, name: "Segunda(o)" },
    { id: 3, name: "Terceira(o)" },
    { id: 4, name: "Quarta(o)" },
    { id: 5, name: "Última(o)" },
  ],
};

export const STATUS_SLOT = {
  pt: [
    { id: "A", name: "Ativo" },
    { id: "I", name: "Inativo" },
    { id: "P", name: "Planejado" },
    { id: "F", name: "Confirmado" },
    { id: "D", name: "Em Discussão" },
    { id: "C", name: "Concluído" },
    { id: "V", name: "Em Aprovação" },
    { id: "N", name: "Não Vinculado a Reunião" },
  ],
  en: [
    { id: "A", name: "Active" },
    { id: "I", name: "Inactive" },
    { id: "C", name: "Concluded" },
    { id: "F", name: "Confirmed" },
    { id: "P", name: "Planned" },
    { id: "D", name: "Under Discussion" },
    { id: "V", name: "Under Approval" },
    { id: "N", name: "Not Linked to a Meet" },
  ],
  es: [
    { id: "A", name: "Activo" },
    { id: "I", name: "Inactivo" },
    { id: "C", name: "Completado" },
    { id: "F", name: "Confirmado" },
    { id: "P", name: "Planeado" },
    { id: "D", name: "En Discusión" },
    { id: "V", name: "En Aprovación" },
    { id: "N", name: "No obligado a la reunión" },
  ],
};

export const STATUS = {
  pt: [
    { id: "O", name: "Aberta" },
    { id: "CF", name: "Confirmada" },
    { id: "C", name: "Cancelada" },
    { id: "CC", name: "Concluída" },
    { id: "UD", name: "Em Discussão" },
  ],
  en: [
    { id: "O", name: "OPEN" },
    { id: "CC", name: "Scheduled" },
    { id: "UD", name: "Under Discussion" },
    { id: "C", name: "Canceled" },
    { id: "CF", name: "Confirmed" },
  ],
  es: [
    { id: "O", name: "Open" },
    { id: "CC", name: "Scheduled" },
    { id: "UD", name: "En Discusión" },
    { id: "C", name: "Canceled" },
    { id: "CF", name: "Confirmado" },
  ],
};

export const STATUS_COMMITTEE = {
  pt: [
    { id: true, name: "Ativo" },
    { id: false, name: "Inativo" },
  ],
  en: [
    { id: true, name: "Ativo" },
    { id: false, name: "Inativo" },
  ],
  es: [
    { id: true, name: "Ativo" },
    { id: false, name: "Inativo" },
  ],
};

export const TYPE_SLOT = {
  pt: [
    { id: "A", name: "Aprovação" },
    { id: "D", name: "Discussão" },
    { id: "I", name: "Informação" },
  ],
  en: [
    { id: "A", name: "Approvation" },
    { id: "D", name: "Discussion" },
    { id: "I", name: "Information" },
  ],
  es: [
    { id: "A", name: "Aprobación" },
    { id: "D", name: "Discusión" },
    { id: "I", name: "Información" },
  ],
};

export const BUDGETED_OPTIONS = {
  pt: [
    { id: "yes", name: "Sim" },
    { id: "no", name: "Não" },
    { id: "na", name: "N/A" },
    { id: "pno", name: "Parte do valor não orçado" },
  ],
  en: [
    { id: "yes", name: "Yes" },
    { id: "no", name: "No" },
    { id: "na", name: "N/A" },
    { id: "pno", name: "Part of value not  budgeted" },
  ],
  es: [
    { id: "yes", name: "Si" },
    { id: "no", name: "No" },
    { id: "na", name: "N/A" },
    { id: "pno", name: "Parte del valor no presupuestado" },
  ],
};

export const STATUS_MATERIAL = {
  pt: [
    { id: 1, name: "Material disponível" },
    { id: 2, name: "Material será disponibilizado até o dia da reunião" },
    { id: 3, name: "Material será apresentado na hora" },
    { id: 4, name: "Sem material suporte" },
  ],
  en: [
    { id: 1, name: "Available Material" },
    { id: 2, name: "Material will be available until meeting date" },
    { id: 3, name: "The material will be presented on time" },
    { id: 4, name: "No support material" },
  ],
  es: [
    { id: 1, name: "Material disponible" },
    {
      id: 2,
      name: "El material estará disponible hasta la fecha de la reunión.",
    },
    { id: 3, name: "El material será presentado a tiempo." },
    { id: 4, name: "Sin material de apoyo" },
  ],
};

export const DAYS = {
  pt: [
    { id: "monday", name: "Segunda-feira" },
    { id: "tuesday", name: "Terça-feira" },
    { id: "wednesday", name: "Quarta-feira" },
    { id: "thursday", name: "Quinta-feira" },
    { id: "friday", name: "Sexta-feira" },
    { id: "saturday", name: "Sábado" },
    { id: "sunday", name: "Domingo " },
  ],
  en: [
    { id: "monday", name: "Monday" },
    { id: "tuesday", name: "Tuesday" },
    { id: "wednesday", name: "Wednesday" },
    { id: "thursday", name: "Thursday" },
    { id: "friday", name: "Friday" },
    { id: "saturday", name: "Saturday" },
    { id: "sunday", name: "Sunday" },
  ],
  es: [
    { id: "monday", name: "lunes" },
    { id: "tuesday", name: "martes" },
    { id: "wednesday", name: "miércoles" },
    { id: "thursday", name: "jueves" },
    { id: "friday", name: "viernes" },
    { id: "saturday", name: "sábado" },
    { id: "sunday", name: "domingo" },
  ],
};

export const DAYSTOMEETFORM = {
  pt: [
    { id: 1, name: "Segunda-feira" },
    { id: 2, name: "Terça-feira" },
    { id: 3, name: "Quarta-feira" },
    { id: 4, name: "Quinta-feira" },
    { id: 5, name: "Sexta-feira" },
    { id: 6, name: "Sábado" },
    { id: 0, name: "Domingo " },
  ],
  en: [
    { id: 1, name: "Monday" },
    { id: 2, name: "Tuesday" },
    { id: 3, name: "Wednesday" },
    { id: 4, name: "Thursday" },
    { id: 5, name: "Friday" },
    { id: 6, name: "Saturday" },
    { id: 0, name: "Sunday" },
  ],
  es: [
    { id: 1, name: "lunes" },
    { id: 2, name: "martes" },
    { id: 3, name: "miércoles" },
    { id: 4, name: "jueves" },
    { id: 5, name: "viernes" },
    { id: 6, name: "sábado" },
    { id: 0, name: "domingo" },
  ],
};

export const ENDAFTER = {
  pt: [
    { id: 0, name: "Sem data definida" },
    { id: 1, name: "Encerrar após 1 encontro" },
    { id: 2, name: "Encerrar após 2 encontros" },
    { id: 3, name: "Encerrar após 3 encontros" },
    { id: 4, name: "Encerrar após 4 encontros" },
    { id: 5, name: "Encerrar após 5 encontros" },
    { id: 6, name: "Encerrar após 6 encontros" },
    { id: 7, name: "Encerrar após 7 encontros" },
    { id: 8, name: "Encerrar após 8 encontros" },
    { id: 9, name: "Encerrar após 9 encontros" },
    { id: 10, name: "Encerrar após 10 encontros" },
    { id: 11, name: "Encerrar após 11 encontros" },
    { id: 12, name: "Encerrar após 12 encontros" },
    { id: 13, name: "Encerrar após 13 encontros" },
    { id: 14, name: "Encerrar após 14 encontros" },
    { id: 15, name: "Encerrar após 15 encontros" },
    { id: 20, name: "Encerrar após 20 encontros" },
    { id: 25, name: "Encerrar após 25 encontros" },
    { id: 30, name: "Encerrar após 30 encontros" },
    { id: 35, name: "Encerrar após 35 encontros" },
    { id: 40, name: "Encerrar após 40 encontros" },
    { id: 45, name: "Encerrar após 45 encontros" },
    { id: 50, name: "Encerrar após 50 encontros" },
    { id: 100, name: "Encerrar após 100 encontros" },
  ],
  en: [
    { id: 0, name: "No date set" },
    { id: 1, name: "End after 1 meeting" },
    { id: 2, name: "End after 2 meetings" },
    { id: 3, name: "End after 3 meetings" },
    { id: 4, name: "End after 4 meetings" },
    { id: 5, name: "End after 5 meetings" },
    { id: 6, name: "End after 6 meetings" },
    { id: 7, name: "End after 7 meetings" },
    { id: 8, name: "End after 8 meetings" },
    { id: 9, name: "End after 9 meetings" },
    { id: 10, name: "End after 10 meetings" },
    { id: 11, name: "End after 11 meetings" },
    { id: 12, name: "End after 12 meetings" },
    { id: 13, name: "End after 13 meetings" },
    { id: 14, name: "End after 14 meetings" },
    { id: 15, name: "End after 15 meetings" },
    { id: 20, name: "End after 20 meetings" },
    { id: 25, name: "End after 25 meetings" },
    { id: 30, name: "End after 30 meetings" },
    { id: 35, name: "End after 35 meetings" },
    { id: 40, name: "End after 40 meetings" },
    { id: 45, name: "End after 45 meetings" },
    { id: 50, name: "End after 50 meetings" },
    { id: 100, name: "End after 100 meetings" },
  ],
  es: [
    { id: 0, name: "Sin fecha establecida" },
    { id: 1, name: "Finalizar después 1 reunion" },
    { id: 2, name: "Finalizar después de 2 reuniones" },
    { id: 3, name: "Finalizar después de 3 reuniones" },
    { id: 4, name: "Finalizar después de 4 reuniones" },
    { id: 5, name: "Finalizar después de 5 reuniones" },
    { id: 6, name: "Finalizar después de 6 reuniones" },
    { id: 7, name: "Finalizar después de 7 reuniones" },
    { id: 8, name: "Finalizar después de 8 reuniones" },
    { id: 9, name: "Finalizar después de 9 reuniones" },
    { id: 10, name: "Finalizar después de 10 reuniones" },
    { id: 11, name: "Finalizar después de 11 reuniones" },
    { id: 12, name: "Finalizar después de 12 reuniones" },
    { id: 13, name: "Finalizar después de 13 reuniones" },
    { id: 14, name: "Finalizar después de 14 reuniones" },
    { id: 15, name: "Finalizar después de 15 reuniones" },
    { id: 20, name: "Finalizar después de 20 reuniones" },
    { id: 25, name: "Finalizar después de 25 reuniones" },
    { id: 30, name: "Finalizar después de 30 reuniones" },
    { id: 35, nombre: "Finalizar después de 35 reuniones" },
    { id: 40, name: "Finalizar después de 40 reuniones" },
    { id: 45, nombre: "Finalizar después de 45 reuniones" },
    { id: 50, name: "Finalizar después de 50 reuniones" },
    { id: 100, name: "Finalizar después de 100 reuniones" },
  ],
};

export const ACTIONS_STATUS = {
  pt: [
    { id: "P", name: "Em Progresso" },
    { id: "A", name: "Atrasada" },
    { id: "C", name: "Concluída" },
  ],
  en: [
    { id: "P", name: "In Progress" },
    { id: "A", name: "Late" },
    { id: "C", name: "Concluded" },
  ],
  es: [
    { id: "P", name: "En progreso" },
    { id: "A", name: "Tarde" },
    { id: "C", name: "Terminado" },
  ],
};

export const ACTION_EMAIL_BODIES = {
  pt: `
Segue ação solicitada no {{actionInfoCommitte}} dia {{actionInfoMeetDate}}.

Slot: {{actionInfoTheme}}
Ação {{actionInfoActionNumber}} - {{actionInfoActionDescription}}
Prazo: {{actionInfoDeadline}}

Gentileza verificar se o prazo está adequado para atender à demanda.
Caso precise de mais tempo, podemos ajustar o prazo.

Atenciosamente,

Secretaria do {{actionInfoCommittee}}
`,
  en: `
Follow the requested action in the {{actionInfoCommitte}} on {{actionInfoMeetDate}}.
 
Slot: {{actionInfoTheme}}
 
Action {{actionInfoActionNumber}} - {{actionInfoActionDescription}}
 
Deadline: {{actionInfoDeadline}}
 
Kindly verify if the deadline is adequate to meet the demand.
 
If you need more time, we can adjust the deadline.
 
Sincerely,
 
Secretary of the {{actionInfoCommittee}}`,
  es: ` 
Siga la acción solicitada en el {{actionInfoCommitte}} el día {{actionInfoMeetDate}}.
 
Tema: {{actionInfoTheme}}
 
Acción {{actionInfoActionNumber}} - {{actionInfoActionDescription}}
 
Plazo: {{actionInfoDeadline}}
 
Por favor, verifique si el plazo es adecuado para cumplir con la demanda.
 
Si necesita más tiempo, podemos ajustar el plazo.
 
Atentamente,
 
Secretaría del {{actionInfoCommittee}}`,
};
